import { Action, combineReducers } from '@ngrx/store';

import { PERSONAL_MEDIA_ITEMS_FEATURE_KEY } from './constants';
import {
  personalMediaItemsReducer,
  PersonalMediaItemsState,
} from './personal-media-items/personal-media-items.reducer';

export interface State {
  [PERSONAL_MEDIA_ITEMS_FEATURE_KEY]: PersonalMediaItemsState;
}

export function reducers(state: State | undefined, action: Action) {
  return combineReducers({
    [PERSONAL_MEDIA_ITEMS_FEATURE_KEY]: personalMediaItemsReducer,
  })(state, action);
}
